var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:_vm.variant},[_c('img',{attrs:{"src":_vm.getIcon}}),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }